import React from "react";
import classNames from "classnames";
import { useTranslation } from "next-i18next";

import { Theme } from "@/shared/utils/theme/theme";
import {
  ThemeDarkIcon,
  ThemeDawnIcon,
  ThemeDayIcon,
  ThemeDuskIcon,
  ThemeHumanBlackIcon,
  ThemeHumanWhiteIcon
} from "../../../assets/CommonIcons";
import { useTheme } from "@/hooks/useTheme";

import styles from "./themeMenu.module.scss";

const themeIcons = {
  dy: ThemeDayIcon,
  dw: ThemeDawnIcon,
  dk: ThemeDuskIcon,
  dm: ThemeDarkIcon,
  adm: ThemeHumanBlackIcon,
  ady: ThemeHumanWhiteIcon
};

const ThemeMenu = () => {
  const { t } = useTranslation();
  const { activeTheme, updateTheme } = useTheme();

  const themeModes = Object.entries(Theme);

  return (
    <ul className={styles["theme-menu"]}>
      {themeModes.map(([id, data]) => {
        const ThemeIcon = themeIcons[data.id];

        if (!ThemeIcon) {
          return null;
        }

        return (
          <li
            key={id}
            className={classNames(styles["theme-menu_list-item"], {
              [styles["is-current"]]: activeTheme === id
            })}
            onClick={() => updateTheme(id)}
          >
            <ThemeIcon />
            <span className={styles["theme-menu_list-title"]}>{t(data.label)}</span>
          </li>
        );
      })}
    </ul>
  );
};

export default ThemeMenu;
